// Provider Action Types
export const FETCH_RADLIST_REQUEST = 'FETCH_RADLIST_REQUEST';
export const FETCH_RADLIST_SUCCESS = 'FETCH_RADLIST_SUCCESS';
export const FETCH_RADLIST_FAILURE = 'FETCH_RADLIST_FAILURE';
 
export const DROPDOWN_FILTER_REQUEST = 'DROPDOWN_FILTER_REQUEST';
export const DROPDOWN_FILTER_SUCCESS = 'DROPDOWN_FILTER_SUCCESS';
export const DROPDOWN_FILTER_FAILURE = 'DROPDOWN_FILTER_FAILURE';